import moment from "jalali-moment";
import React, { useState } from "react";
import { Checkbox } from "@mui/material";
import MuiButton from "../../../shares/MuiButton";
import MuiTextField from "../../../shares/MuiTextField";

const SelectiveOrderModal = (props) => {
  console.log(props.data, props.ids.length);
  return (
    <>
      <div className="flex flex-row justify-end gap-2">
        <div className="mt-2 text-left">
          <MuiTextField
            onChange={(e) => props.setFactorNum(e.target.value)}
            id="outlined-basic"
            label="شماره فاکتور"
            variant="outlined"
            size="small"
            value={props.factorNum}
            autoFocus
          />
        </div>
        <div className="mt-2 text-left">
          <MuiButton
            onClick={() => props.confirm_create("ids")}
            disabled={props.ids.length == 0 || props.factorNum == ""}
            variant="contained"
            color="primary"
            text="تایید نهایی "
          />
        </div>

        <div className="mt-2 text-left">
          <MuiButton
            onClick={() => props.confirm_create("all")}
            variant="contained"
            color="success"
            text="ثبت همه"
            disabled={props.factorNum == ""}
          />
        </div>
      </div>

      <div class="grid grid-cols-4 gap-4 mt-1 mr-2 text-center">
        <div className="mt-3">ردیف</div>
        <div className="mt-3">سند</div>
        {/* <div className="mt-3">کارمند</div> */}
        {/* <div className="mt-3">تاریخ ثبت سفارش</div> */}
        <div className="mt-3">جمع</div>
        <div className="mt-3">انتخاب</div>
      </div>

      <div class="grid grid-cols-4 gap-4 mt-3 mr-2 text-center">
        {props.data.map((item, index) => {
          return [
            <>
              <div className="mt-3">{index + 1}</div>
              <div className="mt-3">{item.unique_id}</div>
              {/* <div className="mt-3">{item.employee}</div> */}
              {/* <div className="mt-3">
                {moment(item.created_at, "YYYY/MM/DD")
                  .locale("fa")
                  .format("YYYY/MM/DD")}
              </div> */}
              <div className="mt-3">{item.total}</div>
              <div className="mt-0">
                <Checkbox
                  onChange={(e) => props.update_ids(item.id)}
                  // checked={}
                />
              </div>
            </>,
          ];
        })}
      </div>
    </>
  );
};

export default SelectiveOrderModal;
